import "./SiteConfigurationGroupInstructionsInfo.html";
import "./SiteConfigurationGroupInstructionsInfo.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

// tslint:disable-next-line:max-line-length
import SiteConfigurationGroupInstructionsInfoComponentController from "./SiteConfigurationGroupInstructionsInfoComponentController";

export class SiteConfigurationGroupInstructionsInfoComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            heading: "<",
            instruction: "<",
        };
        this.controller = SiteConfigurationGroupInstructionsInfoComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/" +
            "Info/Instructions/SiteConfigurationGroupInstructionsInfo.html";
    }
}

module("mmManagePortal").component(
    "irSiteConfigurationGroupInstructionsInfo",
    new SiteConfigurationGroupInstructionsInfoComponent(),
);
